import { useQuery } from '@tanstack/react-query'
import { menuProductsApi } from '@/api/endpoints/menu-products'

/** The window the layout diff looks at: today plus a week of planning. */
export const MENU_DIFF_DAYS = 7

/**
 * Products planned on the restaurant's daily menus in the diff window.
 *
 * Disabled without the menu permission: the panel that reads this is hidden then, and asking anyway
 * would only produce a 403 in the console.
 */
export function useMenuProducts(
  restaurantId?: number | null,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: ['menu-products', restaurantId, MENU_DIFF_DAYS],
    queryFn: () => menuProductsApi.list(restaurantId as number, MENU_DIFF_DAYS),
    enabled: !!restaurantId && (options?.enabled ?? true),
  })
}
